import { plainToInstance } from 'class-transformer'
import { Guid } from 'guid-typescript'

import BaseButtonBuilder, { BaseButtonViewData } from '../index'
import {
  BaseButton,
  ButtonTypes
} from '../types'
import buttonView from './ReactionButtonView.vue'
import setupView from './ReactionSetupView.vue'

export default class ReactionButtonBuilder extends BaseButtonBuilder {
  type = ButtonTypes.Reaction

  titleKey = ButtonTypes.Reaction

  buttonView = buttonView
  setupView = setupView

  icon = '👽'

  data: ReactionButtonData = new ReactionButtonData('👽')

  getData(button?: ReactionButton): ReactionButtonData {
    return new ReactionButtonData(button ? button : plainToInstance(ReactionButton, {
      text: '👽',
      onlyUnique: true,
      grouped: true,
    }))
  }

  create(): ReactionButton {
    return plainToInstance(ReactionButton, {
      ...this.data,
      type: ButtonTypes.Reaction,
      guid: Guid.create().toString(),
    })
  }
}

export class ReactionButtonData implements BaseButtonViewData {
  text = ''
  onlyUnique = false
  grouped = false
  message = ''

  constructor(arg: ReactionButton | string) {

    if (arg instanceof ReactionButton) {
      const { text, onlyUnique, grouped, message } = arg

      if (text) {
        this.text = text
      }
      if (onlyUnique) {
        this.onlyUnique = onlyUnique
      }
      if (message) {
        this.message = message
      }
      if (grouped) {
        this.grouped = grouped
      }
    } else {
      this.text = arg
    }
  }
}

export class ReactionButton implements BaseButton {
  onlyUnique!: boolean
  grouped!: boolean
  message!: string
  guid!: string
  type!: string
  text!: string
}
